import { Divider } from 'antd';
import { UserStatusSwitch, UserStatusSwitchProps } from './StatusSwitch';
import { LogoutOutlined } from '@ant-design/icons';
import { MenuButton } from './MenuButton';
import { AccountInfo } from './AccountInfo';
import { SystemSetting } from './SystemSetting';
import { isInElectron } from 'utils/is';
import { useTranslate } from '@tolgee/react';
import { useCallback } from 'react';
import { useLogout } from 'hooks/useLogout';
import { isAeProduct } from 'productLine';

type UserPopoverContentProps = UserStatusSwitchProps & {
  AE_CONVERSATION: boolean;
};

export const UserPopoverContent = (props: UserPopoverContentProps) => {
  const { AE_CONVERSATION, hidePopover } = props;
  const { t } = useTranslate();
  const logout = useLogout();

  const handleLogout = useCallback(() => {
    hidePopover();
    logout();
  }, [hidePopover, logout]);

  return (
    <div className="max-w-[160px] min-w-[120px]">
      {(!isAeProduct || AE_CONVERSATION) && (
        <>
          <UserStatusSwitch {...props} />
          <Divider className="!my-2" />
        </>
      )}
      <AccountInfo hidePopover={hidePopover} />
      {isInElectron && <SystemSetting hidePopover={hidePopover} />}
      <Divider className="!my-2" />
      <MenuButton
        customIcon={<LogoutOutlined />}
        label={t('other.logout')}
        onClick={handleLogout}
      />
    </div>
  );
};
